import './Works.css';
import { Col, Container,  Row, Image } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import coffee from '../../Assets/coffee.png';
import Button from '../../components/Button/Button';
import React, { useState, useRef } from "react";
import { Link } from 'react-router-dom';
import galaUno from '../../Assets/proyectos/galaUno.png';
import galaDos from '../../Assets/proyectos/galaDos.png';
import enUno from '../../Assets/proyectos/enUno.png';
import enDos from '../../Assets/proyectos/enDos.png';
import enTres from '../../Assets/proyectos/enTres.png';
import raUno from '../../Assets/proyectos/raUno.png';
import raDos from '../../Assets/proyectos/raDos.png';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import { Waypoint } from 'react-waypoint';


import { motion, useScroll } from 'framer-motion';

import Proyectos from '../Proyectos/Proyectos';
// import Portfolio from '../Portfolio/Portfolio';

const Works = ({title, onClick}) => {

    const { ref, inView } = useInView({
        trigger: 'once',
      });
    
      const animationVariants = {
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0.5 },
      };
      const responsiveAnimationVariants = {
        hidden: { opacity: 1, scale: 1 }, // Ajusta la escala inicial para las animaciones responsivas
        visible: { opacity: 1, scale: 0.5 },
      };
      const isResponsive = useMediaQuery({ maxWidth: 768 }); 



    const [isVisible, setIsVisible] = useState(false);

    const handleWaypointEnter = () => {
      setIsVisible(true);
    };
  
    const handleWaypointLeave = () => {
      setIsVisible(false);
    };

    const { t } = useTranslation();

    const { i18n } = useTranslation();
    
      const changeLanguage = (language) => {
        i18n.changeLanguage(language);
      };


    return (
  <Container>



            <Row id='Works'>
                <Col className='sectionW'>
                <hr className='linea'></hr>
                <h1 className='works'>{t('PROJECTS')}</h1>
                </Col>
            </Row>

            <Row className='contieneBanner' xxl={12} xl={6} lg={6}>
                <Col xxl={6} xl={6} lg={8} md={10} sm={12} className='made' >
                <Waypoint
                    onEnter={handleWaypointEnter}
                    onLeave={handleWaypointLeave}
                    bottomOffset="20%"
                />
                    <motion.h2 xxl={12} xl={12} lg={12} md={12} sm={3} 
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }}
                        transition={{ duration: 1 }} 
                        className='bannerUno'>{t('Made with ')} 
                        <span className='negrita'>{t('love')}</span>  
                        {t('... and ')} <span className='negrita'>{t('coffee')}</span></motion.h2>
                </Col>
            </Row>
            {/* <Portfolio /> */}
              <Proyectos />

            </Container>
       
      
    );
}

export default Works;

